































































































import { Box, SecondaryButton, CustomLink, Flex, Button, BaseModal, InputError } from '../../atoms'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { ImageGroup } from '../../molecules'
import { mapActions, mapGetters } from 'vuex'
import { UPLOAD_PROFILE_IMAGE, PROFILE_MODULE, DELETE_PROFILE_IMAGE } from '../../../store/modules/profile/constant'

@Component({
  components: {
    Box,
    SecondaryButton,
    Flex,
    ImageGroup, 
    Button, 
    BaseModal,
    InputError
  },
  methods: {
    ...mapActions(PROFILE_MODULE, [UPLOAD_PROFILE_IMAGE, DELETE_PROFILE_IMAGE])
  }
})
export default class ProfileImageBox extends Vue {
  @Prop({ required: false, type: String }) profileImage!: any
  errorMsg = ''
  modalSuccessVisible = false
  modalDeleteImageVisible = false
  modalDeleteSuccessVisible = false
  submitUploadToggle = false
  profileImageFromProp = ''
  hasProfileImage = false

  @Watch("profileImage")
  onProfileImageRender() {
    this.renderProfileImage()
  }
  
  renderProfileImage() {
    this.profileImageFromProp = this.profileImage
    if(this.profileImage) {
      this.hasProfileImage = true
    }
  }

  onCloseSuccessModal() {
    this.modalSuccessVisible = !this.modalSuccessVisible
  }
  onCloseDeleteImageModal() {
    this.modalDeleteImageVisible = !this.modalDeleteImageVisible
  }
  onCloseDeleteSuccessModal() {
    this.modalDeleteSuccessVisible = !this.modalDeleteSuccessVisible
  }
  clearErrorMsg() {
    this.errorMsg = ''
  }

  async preRenderImage() {
    const files: Array<File> = Array.from((this.$refs.fileInput as any).files);
    this.submitUploadToggle = true
    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    let me = this
    reader.onload = function () {
      if(reader.result != null){
        me.profileImageFromProp = reader.result.toString()
      }
    };

  }
  async uploadFile(e: any) {
    this.clearErrorMsg()
    const errs = [];
    const files: Array<File> = Array.from((this.$refs.fileInput as any).files);
    let formData = new FormData();
    const types = ["image/png", "image/jpeg", "image/jpg"];

    files.forEach((file, i) => {
      if (types.every(type => file.type !== type)) {
        this.errorMsg = 'อนุญาตให้อัพโหลดไฟล์รูปภาพประเภท JPG และ PNG เท่านั้น'
        return
      }

      formData.append('file', file)
    })
    this.submitUploadToggle = false
    const resp = await (this as any)[UPLOAD_PROFILE_IMAGE](formData)
    if (resp.code == 200) {
      this.profileImageFromProp = resp.data.profile_url as string
      this.onCloseSuccessModal();
      (this.$refs.fileInput as any).type = 'text';
      (this.$refs.fileInput as any).type = 'file';
      this.hasProfileImage = true
      return
    }else if(resp.http_status == 413) {
      this.errorMsg = "ขนาดของไฟล์ที่อัพโหลด ห้ามเกิน 2.5 MB"
      this.submitUploadToggle = true
      return
    }else{
      this.errorMsg = resp?.error_message
      this.submitUploadToggle = true
      return
    }
  }
  uploadToggle() {
    (this.$refs.fileInput as HTMLElement).click()
    this.clearErrorMsg()
  }
  async deleteProfileImage() {
    this.clearErrorMsg()
    this.onCloseDeleteImageModal()
    const resp = await (this as any)[DELETE_PROFILE_IMAGE]()
    if (resp.code == 200) {
      this.profileImageFromProp = ''
      this.hasProfileImage = false
      this.onCloseDeleteSuccessModal()
    } else {
      this.errorMsg = resp?.error_message
    }
  }
}
